module.exports = __webpack_public_path__ + "static/media/scrapy.d5e729fa.jpg";